export const urls = {
  country: '/v1/country-changer/request',
};
